import {select, fork, take, put} from 'redux-saga/effects';
import {pascalCase} from 'change-case';
import {persistenceStates} from '@computerrock/formation-core';
import {ampMembershipTypes} from '@ace-de/eua-entity-types';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as memberActionTypes from '../memberActionTypes';
import routePaths from '../../routePaths';

/**
 * Search members
 */
const searchMembers = function* searchMembers({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const membersService = serviceManager.loadService('membersService');
    const {location} = yield select(state => state.router);
    const isDashboardScreenMatch = location?.pathname === routePaths.DASHBOARD;

    yield put({
        type: memberActionTypes.SET_ARE_SEARCH_RESULTS_VALID,
        payload: {areSearchResultsValid: false},
    });

    yield put({
        type: memberActionTypes.SET_MEMBER_SEARCH_RESULTS_PERSISTENCE_STATE,
        payload: {persistenceState: persistenceStates.PENDING},
    });

    const {searchQueryParams} = payload;
    yield fork(fetchRequest, memberActionTypes.SEARCH_MEMBERS_REQUEST, membersService.searchMembers, {
        searchQueryParams,
        searchByMembershipTypes: isDashboardScreenMatch
            ? []
            : Object.keys(ampMembershipTypes).map(ampMembershipType => {
                return {
                    key: pascalCase(ampMembershipType),
                    value: ampMembershipTypes[ampMembershipType],
                };
            }),
    });

    const searchMembersResponseAction = yield take([
        memberActionTypes.SEARCH_MEMBERS_REQUEST_SUCCEEDED,
        memberActionTypes.SEARCH_MEMBERS_REQUEST_FAILED,
    ]);

    yield put({
        type: memberActionTypes.SET_MEMBER_SEARCH_RESULTS_PERSISTENCE_STATE,
        payload: {persistenceState: persistenceStates.READY},
    });

    if (searchMembersResponseAction.error) return;

    const {response} = searchMembersResponseAction.payload;
    const {
        results: memberSearchResults = [],
        resultsPrivate: memberSearchResultsPrivate = [],
        resultsCorporate: memberSearchResultsCorporate = [],
    } = response;

    const {
        totalCount: memberSearchResultsCount,
        totalCountPrivate: memberSearchResultsCountPrivate,
        totalCountCorporate: memberSearchResultsCountCorporate,
    } = response;

    yield put({
        type: memberActionTypes.STORE_MEMBER_SEARCH_RESULTS,
        payload: {
            memberSearchResults,
            memberSearchResultsCount,
            memberSearchResultsPrivate,
            memberSearchResultsCountPrivate,
            memberSearchResultsCorporate,
            memberSearchResultsCountCorporate,
        },
    });

    yield put({
        type: memberActionTypes.SET_ARE_SEARCH_RESULTS_VALID,
        payload: {areSearchResultsValid: true},
    });
};

export default searchMembers;
